import "babel-polyfill";
import "whatwg-fetch";
import "./polyfill";
import Timer from "./clock";
import NavBurger from "./nav-burger";
import Select from "./select";
import DataTable from "./table";
import { Toggle } from "./toggle";
import DatePicker from "./date-picker";
import TimeSelector from "./time-selector";
import TourGroupForm from "./tour-group-form";
import ETR from "./etr";
import Partnership from "./partnership";
import Scanner from "./scanner";
import TIP from "./tip";
import CommissionSplit from "./commission-split";
import Homepage from "./homepage";
import Popup from "./popup";
import PopupScanner from "./popup-scanner";
import Slider from "./slider";
import Snackbar from "./snackbar";
import ZebraPrint from "./zebra-print";
import Print from "./print";
import LoadingSubmitButton from "./loading-submit-button";
import PartnerList from "./partner-list";
import ViewDetails from "./view-details";
import ListStores from './list-stores';
import NameFormat from "./name-format";
import DummyEmail from "./dummy-email";
import Wechat from "./wechat";
import UploadFile from "./upload-file";
import TimezoneSelector from "./timezone-selector";
import CheckSynchronization from "./check-synchronization";

const config = {
    DOM: {
        header: document.querySelector("#header"),
        body: document.querySelector("body"),
        burger: document.querySelector("#js-burger"),
        clock: document.querySelector("#js-clock"),
    },
    MQ: {
        md: window.matchMedia("(max-width: 834px)"),
    },
};

// Init select with autocomplete
// TODO: find a way to fix this eslint rule here
new Select(); // eslint-disable-line no-new

// Init clock
// TODO: find a way to fix this eslint rule here
new Timer(config.DOM.clock); // eslint-disable-line no-new

// Init nav menu
let navBurger = null;

if (config.MQ.md.matches && !navBurger) {
    navBurger = new NavBurger(config.DOM.burger, config);
}

config.MQ.md.addListener((e) => {
    if (e.matches && !navBurger) {
        navBurger = new NavBurger(config.DOM.burger, config);
    } else {
        navBurger.reset();
    }
});

// Init datatable
// TODO: find a way to fix this eslint rule here
new DataTable(); // eslint-disable-line no-new

// Init toggle
// TODO: find a way to fix this eslint rule here
new Toggle().all(); // eslint-disable-line no-new

// Init date picker
const datePicker = new DatePicker(config.MQ.md);

// Init time selector
// TODO: find a way to fix this eslint rule here
new TimeSelector(); // eslint-disable-line no-new

new TimezoneSelector();

const autoSubmitEls = document.querySelectorAll(".js-auto-submit");
autoSubmitEls.forEach((autoSubmitEl) => {
    autoSubmitEl.addEventListener("change", () => {
        autoSubmitEl.closest("form").submit();
    });
});

// Init binding between nationality and province
// TODO: find a way to fix this eslint rule here
new TourGroupForm(datePicker); // eslint-disable-line no-new

// Init ETR fetching
// TODO: find a way to fix this eslint rule here
new ETR(); // eslint-disable-line no-new

// Init partnership
// TODO: find a way to fix this eslint rule here
new Partnership(); // eslint-disable-line no-new

// Init scanner
// TODO: find a way to fix this eslint rule here
new Scanner(); // eslint-disable-line no-new

// Init TIP
// TODO: find a way to fix this eslint rule here
new TIP(); // eslint-disable-line no-new

// Init commission split
// TODO: find a way to fix this eslint rule here
new CommissionSplit(); // eslint-disable-line no-new

// Init homepage code
// TODO: find a way to fix this eslint rule here
new Homepage(); // eslint-disable-line no-new

// Init popup
// TODO: find a way to fix this eslint rule here
new Popup(); // eslint-disable-line no-new

// Init popup scanner
// TODO: find a way to fix this eslint rule here
new PopupScanner(); // eslint-disable-line no-new

// Init slider
// TODO: find a way to fix this eslint rule here
new Slider(); // eslint-disable-line no-new

// Init snackbar
// TODO: find a way to fix this eslint rule here
new Snackbar(); // eslint-disable-line no-new

// Init ZebraPrint
// TODO: find a way to fix this eslint rule here
//new ZebraPrint(); // eslint-disable-line no-new

// Init Print
// TODO: find a way to fix this eslint rule here
new Print(); // eslint-disable-line no-new

// Init Loading button
// TODO: find a way to fix this eslint rule here
new LoadingSubmitButton(); // eslint-disable-line no-new

// Init Partner List
// TODO: find a way to fix this eslint rule here
new PartnerList(); // eslint-disable-line no-new

// Init View Company Details
// TODO: find a way to fix this eslint rule here
new ViewDetails(); // eslint-disable-line no-new

//Init List Stores
new ListStores();
// Init Select Name Format
new NameFormat();

//Init View Company Details
new DummyEmail();

// Agent edit page
new Wechat();

//Init Upload file
new UploadFile();

// Init Check Sync
new CheckSynchronization();

// Loader demo => to be removed after validation
const runButton = document.getElementById("run-loader");
const overlay = document.getElementById("popup-overlay");
const loader = document.getElementById("loader");
if (loader) {
    loader.style.width = "150px";
}

const toggleLoader = () => {
    overlay.classList.toggle("d-n");
    overlay.classList.toggle("d-f");
    loader.classList.toggle("d-n");
};

if (runButton) {
    runButton.addEventListener("click", () => {
        toggleLoader();
        setTimeout(toggleLoader, 10000);
    });
}
